export default __webpack_public_path__ + "static/media/Footer3_black.f3fea41c.png";